module.exports = __webpack_public_path__ + "static/img/100x100_ICONS_3.123fe4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/100x100_ICONS_3.png
// module id = yuEN
// module chunks = 0